/* eslint-disable react/no-children-prop */
import React, { FC } from 'react';
import { Button, Container, Grid } from '@mui/material';
import useStyles from '../../assets/styles/components/optionMenu';

import { ReactComponent as IconArrow } from '../../assets/images/svg/user/icon_arrow.svg';

type Props = {
  Icon?: FC<React.SVGProps<SVGSVGElement>>;
  img?: string;
  title: string;
  fn?: () => void;
  marginBtn?: string;
};

const OptionMenu: FC<Props> = ({
  Icon,
  img,
  title,
  fn,
  marginBtn = '10px 20px',
}) => {
  const classeStyle = useStyles({ marginBtn });

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Grid xs={12} container item justifyContent="left">
        <Button onClick={() => fn && fn()} className={classeStyle.btn}>
          <p className={classeStyle.title}>
            {img && (
              <img
                style={{ width: 20, marginRight: 10 }}
                src={img}
                alt="icon"
              />
            )}
            {Icon && <Icon className={classeStyle.iconLeft} />} {title}
          </p>
          <IconArrow />
        </Button>
      </Grid>
    </Container>
  );
};

export default OptionMenu;
